import React from "react";
import { FaBug, FaCheckCircle } from "react-icons/fa";

const projects = [
  {
    icon: <FaCheckCircle size={11} />,
    title: "E2E Transaction Test Automation",
    type: "Test Automation",
    problem:
      "Transaction flows spanned multiple layers — API, database, and back office — with no automated coverage. Each release required slow, error-prone manual validation across all systems.",
    role: [
      "Executed API requests with assertion validation",
      "Verified database state after transactions",
      "Automated back office workflows",
      "Captured logs, request/response payloads, and screenshots",
      "Integrated results into Testmo for structured reporting",
    ],
    tools: ["Playwright", "Testmo", "API Testing", "DB Validation"],
    outcome:
      "Reduced manual regression effort and improved release confidence by automating full transaction lifecycle validation. Enabled consistent validation across API, database, and back office systems with zero manual intervention.",
    link: null,
    status: "Automated",
  },
  {
    icon: <FaBug size={11} />,
    title: "Crypto Bros Calculator",
    type: "Full-Stack Web App",
    problem:
      "Crypto enthusiasts needed a fast, reliable tool to calculate gains, losses, and portfolio value without relying on bloated third-party apps.",
    role: "Designed and built the full application end-to-end, integrating a live crypto price API to pull real-time data and display calculated results instantly.",
    tools: ["ReactJS", "Bootstrap", "REST API", "Vercel"],
    outcome:
      "Live app deployed on Vercel. Handles real-time price lookups and crypto calculations with a clean, responsive UI.",
    link: "https://crypto-bros-calculator.vercel.app/",
    status: "Live",
  },
];

const Work = () => {
  return (
    <section name="work" className="w-full bg-[#2F4156] py-12">
      <div className="max-w-5xl mx-auto px-6">
        <div className="mb-16">
          <p className="text-sm font-medium text-[#C8D9E6] tracking-widest uppercase mb-3">
            Selected Work
          </p>
          <h2 className="text-4xl font-bold text-[#F5EFEB]">Projects</h2>
        </div>

        <div className="flex flex-col gap-8">
          {projects.map((project, i) => (
            <div key={i} className="rounded-xl p-8 bg-[#F5EFEB] hover:bg-[#FFFFFF] transition-colors">
              <div className="flex items-start justify-between gap-4 mb-6">
                <div>
                  <span className="flex items-center gap-1.5 text-xs font-medium text-[#567C8D] uppercase tracking-widest">
                    {project.icon}
                    {project.type}
                  </span>
                  <h3 className="text-2xl font-bold text-[#2F4156] mt-1">
                    {project.title}
                  </h3>
                </div>
                <span className="shrink-0 text-xs font-medium bg-[#C8D9E6] text-[#2F4156] px-3 py-1 rounded-full">
                  {project.status}
                </span>
              </div>

              <div className="grid sm:grid-cols-3 gap-6 mb-8">
                <div>
                  <p className="text-xs font-semibold text-[#567C8D] uppercase tracking-widest mb-2">Problem</p>
                  <p className="text-sm text-[#567C8D] leading-relaxed">{project.problem}</p>
                </div>
                <div>
                  <p className="text-xs font-semibold text-[#567C8D] uppercase tracking-widest mb-2">What I Did</p>
                  {Array.isArray(project.role) ? (
                    <ul className="flex flex-col gap-1.5">
                      {project.role.map((item) => (
                        <li key={item} className="flex items-start gap-2 text-sm text-[#567C8D] leading-relaxed">
                          <span className="mt-1.5 shrink-0 w-1 h-1 rounded-full bg-[#567C8D]" />
                          {item}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p className="text-sm text-[#567C8D] leading-relaxed">{project.role}</p>
                  )}
                </div>
                <div>
                  <p className="text-xs font-semibold text-[#567C8D] uppercase tracking-widest mb-2">Outcome</p>
                  <p className="text-sm text-[#567C8D] leading-relaxed">{project.outcome}</p>
                </div>
              </div>

              <div className="flex flex-wrap items-center justify-between gap-4 pt-6 border-t border-[#C8D9E6]">
                <div className="flex flex-wrap gap-2">
                  {project.tools.map((tool) => (
                    <span key={tool} className="text-xs font-medium bg-[#C8D9E6] text-[#2F4156] px-3 py-1 rounded-full">
                      {tool}
                    </span>
                  ))}
                </div>
                {project.link && (
                  <a href={project.link} target="_blank" rel="noreferrer"
                    className="text-sm font-medium text-[#567C8D] hover:text-[#2F4156] transition-colors">
                    View Live →
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Work;
